import { OptionModel } from "components/helpers"
import { MultiSelect, ValidationMessage } from "components/library"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useGetRatesByCalculationType } from "./hook/useGetRatesByCalculationType"

interface Props {
  calculationTypeId: number
  agreements: number[]
  rebates: number[]
  products: number[]
  errorMessage?: string
  displayValidations?: boolean
  fieldName: string
  heading: string
  required?: boolean
  onChange: (e: any) => void
  selectedItems: any[]
  disabled?: boolean
}

export const RateByCalculationTypeMultiselect: React.FC<Props> = ({
  calculationTypeId,
  agreements,
  rebates,
  products,
  errorMessage,
  displayValidations,
  fieldName,
  heading,
  required,
  onChange,
  selectedItems,
  disabled,
}) => {
  const { t } = useTranslation()
  const [searchTimeout, setSearchTimeout] = useState<any>()
  const [query, setQuery] = useState<string>("")
  const { ratesByCalculationType } = useGetRatesByCalculationType(
    calculationTypeId,
    agreements,
    query,
    rebates,
    products
  )
  const [rateList, setRateList] = useState<OptionModel[]>([])

  const [ratesSelected, setRatesSelected] = useState<OptionModel[]>(
    selectedItems
      ? selectedItems.map((item) => ({
          value: item,
          title: item,
          hidden: true,
        }))
      : []
  )
  const textChanged = (event: any) => {
    clearTimeout(searchTimeout)
    setSearchTimeout(
      setTimeout(() => {
        setQuery(event.filter)
      }, 500)
    )
  }

  const getSelectedRateValue = (ids: string[]) => {
    const rateSelectedButNotInList = ids
      .filter((p) => !rateList.map((c) => c.value).includes(p))
      ?.map((c) => ({
        value: c,
        title: ratesSelected.find((psi) => psi.value === c)?.title ?? c,
        hidden: true,
      }))
    const options = rateList.concat(rateSelectedButNotInList)
    setRateList(options)

    const selectedItems = ids.map((c) => ({
      value: c,
      title:
        rateList?.find((aps) => aps.value === c)?.title ??
        ratesSelected.find((psi) => psi.value === c)?.title ??
        c,
      hidden: true,
    }))
    return selectedItems
  }

  React.useEffect(() => {
    if (ratesByCalculationType.data && ratesByCalculationType.data.length > 0) {
      const rateSelectedButNotInList =
        selectedItems.length > 0
          ? ratesSelected
              .filter(
                (us) =>
                  !ratesByCalculationType.data
                    .map((u) => u.value)
                    .includes(us.value)
              )
              ?.map((us) => ({
                value: us.value,
                title: us.title,
                hidden: true,
              }))
          : []

      const ratesTemp = ratesByCalculationType.data.concat(
        rateSelectedButNotInList
      )
      setRateList(ratesTemp)
    } else {
      setRateList([])
    }
  }, [ratesByCalculationType.data])
  return (
    <>
      <MultiSelect
        options={rateList}
        required={required}
        optionLabel="title"
        optionValue="value"
        name={fieldName}
        heading={heading}
        value={rateList?.length > 0 ? selectedItems : []}
        onChange={(e) => {
          onChange(e)
          setRatesSelected(getSelectedRateValue(e.value))
        }}
        onFilter={(e) => {
          textChanged(e)
        }}
        placeholder={
          ratesByCalculationType.data && ratesByCalculationType.data?.length < 1
            ? t("no-records-found")
            : t("select-options")
        }
        disabled={disabled}
      />
      {errorMessage && displayValidations && (
        <ValidationMessage
          messageError={errorMessage}
          showMessage={
            displayValidations &&
            errorMessage !== undefined &&
            errorMessage !== null &&
            errorMessage.length > 0
          }
        />
      )}
    </>
  )
}
